import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b23fdec8"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b23fdec8')) {
      api.createRecord('b23fdec8', component.options)
    } else {
      api.reload('b23fdec8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=b23fdec8", function () {
      api.rerender('b23fdec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/contract/edit.vue"
export default component.exports